export default __webpack_public_path__ + "static/media/fUSD.77c6df28.png";